// extracted by mini-css-extract-plugin
export default {"div":"ProductList_div__s9mWr"};